module.exports = __webpack_public_path__ + "summer/img/bind.6ef48d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/present/bind.png
// module id = lEKr
// module chunks = 39